import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import { keys } from '@/api/queryKeys';
import type { Announcement } from '@/api/types';

export function useActiveAnnouncements(enabled: boolean) {
  return useQuery({
    queryKey: keys.announcements,
    queryFn: () => api<Announcement[]>('/announcements'),
    enabled,
    // Ticket 0028. Refetched on every route change -- eight times in one
    // observed session -- for a banner an admin publishes occasionally.
    staleTime: 5 * 60_000,
  });
}
